import { useState, useEffect } from 'react'
import { Container, Row, Col } from '@ui/wrapper'
import TeamMember from '@components/team-member'
import SectionTitle from '@ui/section-title'
import { TeamWrapper, TeamWrapperInternal, CenteredBorder } from './style'

const TeamArea = ({ data, data2, ...rest }) => {
  const maxPics =
    data.items.length > data2.items.length
      ? data.items.length
      : data2.items.length
  const loopArray = Array.from(
    { length: Math.ceil(maxPics / 2) },
    (_, i) => i * 2
  )

  const [isSmScreen, setIsSmScreen] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsSmScreen(window.innerWidth < 768) // md breakpoint
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <TeamWrapper {...rest}>
      <Container px={[null, null, null, '30px']} mb="30px">
        {data.title && (
          <SectionTitle mb={['45px', null, null, '70px']} title={data.title} />
        )}
        {!isSmScreen &&
          loopArray.map((i) => (
            <Row
              key={'row-' + i.toString()}
              gutters={{ lg: 60 }}
              style={{ margin: '0 -15px' }}
              className="position-relative"
            >
              <Col md={6}>
                {data?.section_title && i === 0 && (
                  <SectionTitle
                    mb={['45px', null, null, '70px']}
                    subtitle={data.section_title.title}
                    layout={2}
                  />
                )}
                <Row gutters={{ lg: 60 }}>
                  {data?.items?.slice(i, i + 2).map((member) => (
                    <Col md={6} key={member.id} mb="30px">
                      <TeamMember
                        layout={2}
                        image={member.images?.[0]}
                        name={member.name}
                        designation={member.designation}
                        socials={member.socials}
                      />
                    </Col>
                  ))}
                </Row>
              </Col>
              <Col md={6}>
                <TeamWrapperInternal index={i}>
                  {data2?.section_title && i === 0 && (
                    <SectionTitle
                      mb={['45px', null, null, '70px']}
                      subtitle={data2.section_title.title}
                      layout={2}
                    />
                  )}
                  <Row gutters={{ lg: 60 }}>
                    {data2?.items?.slice(i, i + 2).map((member) => (
                      <Col md={6} key={member.id} mb="30px">
                        <TeamMember
                          layout={2}
                          image={member.images?.[0]}
                          name={member.name}
                          designation={member.designation}
                          socials={member.socials}
                        />
                      </Col>
                    ))}
                  </Row>
                </TeamWrapperInternal>
              </Col>
              <CenteredBorder />
            </Row>
          ))}
        {isSmScreen && (
          <>
            {[data, data2].map((sectionData, index) => (
              <div key={index} style={{ marginTop: index === 1 ? 40 : 0 }}>
                <SectionTitle
                  mb={['45px', null, null, '70px']}
                  subtitle={sectionData.section_title.title}
                  layout={2}
                />
                {sectionData.items.map((member) => (
                  <Row key={member.id} gutters={{ lg: 60 }}>
                    <Col md={6} key={member.id} mb="30px">
                      <TeamMember
                        layout={2}
                        image={member.images?.[0]}
                        name={member.name}
                        designation={member.designation}
                        socials={member.socials}
                      />
                    </Col>
                  </Row>
                ))}
              </div>
            ))}
          </>
        )}
      </Container>
    </TeamWrapper>
  )
}

export default TeamArea
